import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { ServicioSesion } from '@app/services/sesion/sesion.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  private _sesion = inject(ServicioSesion);
  private _router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const permisoRequerido = route.data['permiso'] as string | string[];

    if (!permisoRequerido) {
      return true;
    }

    const permisos = Array.isArray(permisoRequerido) ? permisoRequerido : [permisoRequerido];

    if (permisos.some(p => this._sesion.can(p))) {
      return true;
    }

    Swal.fire({
        icon: 'error',
        title: 'Acceso Denegado',
        text: 'No tienes permisos suficientes para acceder a esta sección.',
        timer: 3000,
        showConfirmButton: false
    });
    
    return this._router.parseUrl('/dashboard');
  }
}